<template>
  <section class="transaction">
    <div class="info overflow1 date">{{ infoData.date }}</div>
    <div class="info overflow1 totalprice">
      {{
        infoData.totalprice == "/"
          ? infoData.totalprice
          : infoData.totalprice + "（万元）"
      }}
    </div>
    <div class="info overflow1 startfloorprice">
      {{
        infoData.startfloorprice == "/"
          ? infoData.startfloorprice
          : infoData.startfloorprice + "（元/㎡）"
      }}
    </div>
    <div class="info overflow1 tradeprice">
      {{
        infoData.tradeprice == "/"
          ? infoData.tradeprice
          : infoData.tradeprice + "（万元/亩）"
      }}
    </div>
    <div class="info overflow1 competecompany">
      {{ infoData.competecompany }}
    </div>
    <img
      class="look-img cpqy"
      src="./../../../assets/imgs/landInfo/cpqy.png"
      alt=""
      @click="showCpqy = !showCpqy"
    />
    <img
      class="look-img cjjl"
      src="./../../../assets/imgs/landInfo/cjjl.png"
      alt=""
      @click="showCjjl = !showCjjl"
    />
    <div class="list-box">
      <div class="cpqy-box" v-show="showCpqy">
        <div class="close-box" @click="showCpqy = false"></div>
        <div class="table-box">
          <el-table
            :data="cpqyList"
            :header-cell-style="{
              background: '#246B95',
              color: '#f1f1f1',
            }"
            :max-height="400"
            height="400"
            style="width: 100%"
            ref="multipleTable"
          >
            <el-table-column
              prop="categoryStr1"
              label="竞价情况"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="number" label="企业" align="center">
            </el-table-column>
            <el-table-column prop="proportion" label="叫价" align="center">
            </el-table-column>
            <el-table-column prop="proportion" label="宣告次数" align="center">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="cjjl-box" v-show="showCjjl">
        <div class="close-box" @click="showCjjl = false"></div>
        <div class="table-box">
          <el-table
            :data="cpqyList"
            :header-cell-style="{
              background: '#246B95',
              color: '#f1f1f1',
            }"
            :max-height="400"
            height="400"
            style="width: 100%"
            ref="multipleTable"
          >
            <el-table-column prop="number" label="企业" align="center">
            </el-table-column>
            <el-table-column prop="proportion" label="号牌" align="center">
            </el-table-column>
            <el-table-column prop="proportion" label="最高出价" align="center">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      infoData: "",
      showCpqy: false,
      showCjjl: false,
      cpqyList: [],
      cjjlList: [],
    };
  },

  components: {},

  mounted() {
    this.bus.$on("setLandInfo", (val) => {
      this.infoData = val;
    });
  },

  methods: {},
};
</script>
<style lang='scss' scoped>
.transaction {
  width: 872px;
  height: 292px;
  background-image: url("./../../../assets/imgs/landInfo/transaction.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  margin-top: 20px;
  .overflow1 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre-wrap;
    word-break: break-all;
  }
  .info {
    color: #fff;
    font-size: 32px;
    position: absolute;
  }
  .date {
    left: 248px;
    top: 78px;
  }
  .totalprice {
    left: 640px;
    top: 78px;
  }
  .startfloorprice {
    left: 248px;
    top: 124px;
    max-width: 220px;
  }
  .tradeprice {
    left: 640px;
    top: 124px;
  }
  .competecompany {
    left: 248px;
    top: 169px;
  }
  .look-img {
    width: 156px;
    height: 40px;
    cursor: pointer;
    position: absolute;
  }
  .cpqy {
    left: 248px;
    top: 225px;
  }
  .cjjl {
    left: 640px;
    top: 225px;
  }
  .cpqy-box {
    width: 595px;
    height: 469px;
    background-image: url("./../../../assets/imgs/landInfo/cpqy_list.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding-top: 60px;
    box-sizing: border-box;
    position: relative;
  }
  .cjjl-box {
    width: 595px;
    height: 469px;
    background-image: url("./../../../assets/imgs/landInfo/cjjl_list.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin-top: 20px;
    padding-top: 60px;
    box-sizing: border-box;
    position: relative;
  }
  .close-box {
    position: absolute;
    width: 80px;
    height: 40px;
    right: 15px;
    top: 10px;
    cursor: pointer;
  }
  ::v-deep .el-table {
    color: #f1f1f1;
    background-color: transparent;
    .el-table__body-wrapper {
      background-color: transparent;
      // padding: 0 5px;
    }
    .el-table__body {
      width: 100% !important;
    }
    .el-table__header-wrapper {
      background: #246b95;
      .el-checkbox {
        display: none;
      }
    }
    th.el-table__cell > .cell {
      font-size: 33px;
      //padding: 0 0 0.3rem 0;
      // line-height: 1.2rem;
    }
    th.el-table__cell.is-leaf {
      border-bottom: none;
    }
    td.el-table__cell div {
      font-size: 30px;
      padding: 0 15px;
    }
    .el-table__cell {
      padding: 0rem 0;
    }
    td.el-table__cell,
    .el-table th.el-table__cell.is-leaf {
      border-bottom: none;
    }
    .el-table__row:nth-child(odd) {
      background: transparent;
    }
    .el-table__row:nth-child(even) {
      // &:nth-child(2n) {
      //   background-color: 4b4b4bb;
      // }
      background: rgba(120, 119, 119, 0.42);
    }
    .sort-caret {
      border-width: 11px;
    }
    .caret-wrapper {
      height: 60px;
    }
  }
  ::v-deep .el-table--border,
  .el-table--group {
    border: none;
  }
  ::v-deep .el-table--border .el-table__cell,
  .el-table__body-wrapper
    .el-table--border.is-scrolling-left
    ~ .el-table__fixed {
    border-color: #f4f6f81a;
  }
  ::v-deep
    .el-table--enable-row-hover
    .el-table__body
    tr:hover
    > td.el-table__cell {
    background: none;
  }
  ::v-deep .el-table .cell {
    line-height: 1.8;
    padding: 0;
    max-width: 400px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }
  ::v-deep.el-table ::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 15px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 20px;
  }
  ::v-deep.el-table ::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px #409eff;
    background-color: #409eff;
  }
  ::v-deep.el-table ::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px #a1a1a1;
    border-radius: 0;
  }
  .list-box {
    position: absolute;
    left: -680px;
    bottom: 0;
  }
}
</style>